import { ProductComparison } from './ProductComparison';

const productComparisons = document.querySelectorAll('.ce-table-productcomparison');

productComparisons.forEach((element) => {
    new ProductComparison(element, {
        tickUrl: plugins?.config?.productcomparison?.tickUrl,
    });
});
